import { Stack } from "@mantine/core";
import { Link } from "react-router-dom";

import style from "./privacy.module.css";

export const PrivacyMenu = () => {
    return (
        <Stack w={"100%"}>
            <Link className={style.link} to="/privacy">Vi tar personvern på alvor</Link>

            <Link className={style.link} to="/privacy-policy">Data- og Personvernserklæring    </Link>

            <Link className={style.link} to="/terms-of-service">Vilkår for bruk</Link>

            <Link className={style.link} to="/gdpr">Hvordan vi følger GDPR</Link>

            <Link className={style.link} to="/responsible-reporting">Ansvarlig rapportering</Link>
        </Stack>
    );
};
